export interface SchoolManagerInterface {
  name: string
  account: string
  phone?: string | null
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
}

export class SchoolManager implements SchoolManagerInterface {
  name: string
  account: string
  phone?: string | null
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number

  constructor(props: SchoolManagerInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      account: _account,
      phone: _phone,
      id: _id,
      schoolId: _schoolId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.account = _account
    this.phone = _phone
    this.id = _id
    this.schoolId = _schoolId
  }
}
